module.exports = __webpack_public_path__ + "img/pichincha.6d4c327b.png";